(()=>{
if(window.__hrUpnovaI18nV2)return;window.__hrUpnovaI18nV2=1;
const lang=(document.documentElement.lang||'').toLowerCase();
const I=lang.startsWith('it')?0:lang.startsWith('es')?1:lang.startsWith('de')?2:lang.startsWith('pt')?3:-1;
if(I<0)return;

const D={
'The Fall Sale':["Saldi d'autunno","Rebajas de otoño","Herbst-Sale","Saldos de outono"],
'THE HALLOWEEN SALE':['SALDI DI HALLOWEEN','REBAJAS DE HALLOWEEN','DER HALLOWEEN SALE','SALDOS DE HALLOWEEN'],
'FINAL HOURS':['ULTIME ORE','ÚLTIMAS HORAS','LETZTE STUNDEN','ÚLTIMAS HORAS'],
'OR BUY 3 GET 2 FREE':['O COMPRA 3 E RICEVI 2 GRATIS','O COMPRA 3 Y LLÉVATE 2 GRATIS','ODER KAUFE 3, ERHALTE 2 GRATIS','OU COMPRA 3 E RECEBE 2 GRÁTIS'],
'Yellow Gold Plated':['Placcato oro giallo','Chapado en oro amarillo','Gelbvergoldet','Banhado a ouro amarelo'],
'White Gold Plated':['Placcato oro bianco','Chapado en oro blanco','Weißvergoldet','Banhado a ouro branco'],
'925 Sterling Silver':['Argento 925','Plata de ley 925','925er Sterlingsilber','Prata de lei 925'],
'UNTIL STOCKS LAST':['FINO A ESAURIMENTO SCORTE','HASTA AGOTAR EXISTENCIAS','SOLANGE DER VORRAT REICHT','ATÉ ESGOTAR O STOCK'],
'WHILE STOCKS LAST':['FINO A ESAURIMENTO SCORTE','HASTA AGOTAR EXISTENCIAS','SOLANGE DER VORRAT REICHT','ATÉ ESGOTAR O STOCK'],
'Choose gift':['Scegli regalo','Elige regalo','Geschenk wählen','Escolher oferta'],
'Choose your gift':['Scegli il tuo regalo','Elige tu regalo','Wähle dein Geschenk','Escolha a sua oferta'],
'Choose free gift':['Scegli un regalo gratuito','Elige un regalo gratis','Gratisgeschenk wählen','Escolher oferta grátis'],
'Choose your free gift':['Scegli il tuo regalo gratuito','Elige tu regalo gratis','Wähle dein Gratisgeschenk','Escolha a sua oferta grátis'],
'Select gift':['Seleziona regalo','Selecciona regalo','Geschenk auswählen','Selecionar oferta'],
'Select your gift':['Seleziona il tuo regalo','Selecciona tu regalo','Wähle dein Geschenk aus','Selecione a sua oferta'],
'Claim your free gift!':['Scegli il tuo regalo gratuito!','¡Elige tu regalo gratis!','Wähle dein Gratisgeschenk!','Escolha a sua oferta grátis!'],
'Claim your free gift':['Scegli il tuo regalo gratuito','Elige tu regalo gratis','Wähle dein Gratisgeschenk','Escolha a sua oferta grátis'],
'Claim your free Free!':['Scegli il tuo regalo gratuito!','¡Elige tu regalo gratis!','Wähle dein Gratisgeschenk!','Escolha a sua oferta grátis!'],
'Claim your free Free':['Scegli il tuo regalo gratuito','Elige tu regalo gratis','Wähle dein Gratisgeschenk','Escolha a sua oferta grátis'],
'Claim free gift':['Scegli il regalo gratuito','Elige el regalo gratis','Gratisgeschenk auswählen','Escolher oferta grátis'],
'Free gift unlocked!':['Regalo gratuito sbloccato!','¡Regalo gratis desbloqueado!','Gratisgeschenk freigeschaltet!','Oferta grátis desbloqueada!'],
'You may also like:':['Potrebbero piacerti:','También te puede gustar:','Das könnte dir gefallen:','Também poderá gostar de:'],
'You may also like':['Potrebbero piacerti','También te puede gustar','Das könnte dir gefallen','Também poderá gostar de'],
'You might also like:':['Potrebbero piacerti:','También te puede gustar:','Das könnte dir gefallen:','Também poderá gostar de:'],
'You might also like':['Potrebbero piacerti','También te puede gustar','Das könnte dir gefallen','Também poderá gostar de'],
'Frequently bought together':['Spesso acquistati insieme','Comprados juntos con frecuencia','Häufig zusammen gekauft','Frequentemente comprados em conjunto'],
'Recommended for you':['Consigliati per te','Recomendados para ti','Für dich empfohlen','Recomendados para si'],
'Add to cart':['Aggiungi al carrello','Añadir al carrito','In den Warenkorb','Adicionar ao carrinho'],
'View cart':['Vedi carrello','Ver carrito','Warenkorb ansehen','Ver carrinho'],
'Shopping cart':['Carrello','Carrito','Warenkorb','Carrinho'],
'Go to checkout':['Vai al checkout','Ir al pago','Zur Kasse','Ir para o checkout'],
'Proceed to checkout':['Vai al checkout','Ir al pago','Zur Kasse','Ir para o checkout'],
'Continue to checkout':['Continua al checkout','Continuar al pago','Weiter zur Kasse','Continuar para o checkout'],
'Estimated total':['Totale stimato','Total estimado','Geschätzte Gesamtsumme','Total estimado'],
'Shipping':['Spedizione','Envío','Versand','Envio'],
'Taxes':['Imposte','Impuestos','Steuern','Impostos'],
'You save':['Risparmi','Ahorras','Du sparst','Poupa'],
'Save':['Risparmia','Ahorra','Sparen','Poupar'],
'Free':['Gratis','Gratis','Gratis','Grátis'],
'Gift':['Regalo','Regalo','Geschenk','Oferta'],
'Products':['Prodotti','Productos','Produkte','Produtos'],
'SUMMER FLASH SALE:':["Saldi d'autunno:",'Rebajas de otoño:','Herbst-Sale:','Saldos de outono:'],
'SUMMER FLASH SALE':["Saldi d'autunno",'Rebajas de otoño','Herbst-Sale','Saldos de outono'],
'40% OFF':['-40%','-40%','40 % RABATT','-40%'],
'Buy 2 Jewelry - get 1 free':['Compra 2 gioielli, ricevine 1 gratis','Compra 2 joyas y llévate 1 gratis','2 Schmuckstücke kaufen, 1 gratis','Compre 2 peças de joalharia e receba 1 grátis'],
'Buy 3 Jewelry - get 2 free':['Compra 3 gioielli, ricevine 2 gratis','Compra 3 joyas y llévate 2 gratis','3 Schmuckstücke kaufen, 2 gratis','Compre 3 peças de joalharia e receba 2 grátis'],
'Buy 2 Jewellery - get 1 free':['Compra 2 gioielli, ricevine 1 gratis','Compra 2 joyas y llévate 1 gratis','2 Schmuckstücke kaufen, 1 gratis','Compre 2 peças de joalharia e receba 1 grátis'],
'Buy 3 Jewellery - get 2 free':['Compra 3 gioielli, ricevine 2 gratis','Compra 3 joyas y llévate 2 gratis','3 Schmuckstücke kaufen, 2 gratis','Compre 3 peças de joalharia e receba 2 grátis'],
'No thanks':['No, grazie','No, gracias','Nein, danke','Não, obrigado'],
'Back':['Indietro','Atrás','Zurück','Voltar'],
'Done':['Fatto','Listo','Fertig','Concluído'],
'Select':['Seleziona','Seleccionar','Auswählen','Selecionar'],
'Selected':['Selezionato','Seleccionado','Ausgewählt','Selecionado'],
'Your rewards':['I tuoi vantaggi','Tus ventajas','Deine Vorteile','As suas vantagens'],
'Rewards':['Vantaggi','Ventajas','Vorteile','Vantagens'],
'Unlock gift':['Sblocca regalo','Desbloquear regalo','Geschenk freischalten','Desbloquear oferta'],
'Unlock free gift':['Sblocca il regalo gratuito','Desbloquear regalo gratis','Gratisgeschenk freischalten','Desbloquear oferta grátis']
};
const lower={};Object.keys(D).forEach(k=>lower[k.toLowerCase()]=k);
const N=s=>String(s||'').replace(/\s+/g,' ').trim();

/* State-aware handling of the "all rewards unlocked" headline:
   Upnova only rewrites this node when its own expected text matches, so a blind
   translation freezes the message. Translate it only when the widget shows no
   "add X more" progress prompt, and restore the original English as soon as a
   progress prompt reappears so Upnova can take back control. */
const UN_MAIN=["you've unlocked all rewards!","you’ve unlocked all rewards!","you've unlocked all bonuses!","you’ve unlocked all bonuses!","you unlocked all bonuses!"];
const UN_GIFTS=['all gifts unlocked!'];
const UN_MAIN_TR=['Hai sbloccato tutti i vantaggi!','¡Has desbloqueado todas las ventajas!','Du hast alle Vorteile freigeschaltet!','Desbloqueou todas as vantagens!'];
const UN_GIFTS_TR=['Hai sbloccato tutti i regali!','¡Has desbloqueado todos los regalos!','Alle Geschenke freigeschaltet!','Desbloqueou todas as ofertas!'];
const unlockOrig=new WeakMap();
const PROGRESS_RX=/\badd\s+(?:\d+|one|a|another)\s+more\b|\baway\s+from\b|\baggiungi(?:ne)?\s+(?:ancora\s+)?\d+|\bti\s+mancano\b|\bañade\s+\d+|\bte\s+faltan\b|\bfüge\s+noch\b|\blege\s+noch\b|\badicione\s+mais\b|\bfaltam\b/i;
function rootInProgress(node){
 try{const r=node.getRootNode?node.getRootNode():document;return PROGRESS_RX.test(String((r&&r.textContent)||''));}catch(e){return false;}
}
function handleUnlock(n){
 const raw=n.nodeValue,core=N(raw).toLowerCase();
 const inMain=UN_MAIN.indexOf(core)>-1,inGifts=UN_GIFTS.indexOf(core)>-1;
 if(inMain||inGifts){
  if(rootInProgress(n))return true;
  const tr=(inMain?UN_MAIN_TR:UN_GIFTS_TR)[I];
  if(N(raw)!==tr){unlockOrig.set(n,raw);n.nodeValue=tr;}
  return true;
 }
 if((core===UN_MAIN_TR[I].toLowerCase()||core===UN_GIFTS_TR[I].toLowerCase())&&rootInProgress(n)){
  const o=unlockOrig.get(n);if(o&&n.nodeValue!==o)n.nodeValue=o;
  return true;
 }
 return false;
}

function promo(n,m){
 return [
  `Compra ${n} gioielli, ricevine ${m} gratis`,
  `Compra ${n} joyas y llévate ${m} gratis`,
  `${n} Schmuckstücke kaufen, ${m} gratis`,
  `Compre ${n} peças de joalharia e receba ${m} grátis`
 ][I];
}
function coreTranslate(core){
 let key=lower[core.toLowerCase()];
 if(key)return D[key][I];

 let m=core.match(/^Buy\s+(\d+)\s*(?:Jewelry|Jewellery)?\s*[-–—,:]\s*(?:and\s+)?get\s+(\d+)\s+free!?$/i);
 if(m)return promo(m[1],m[2]);

 m=core.match(/^Buy\s+(\d+)\s+(?:Jewelry|Jewellery)\s+and\s+get\s+(\d+)\s+free!?$/i);
 if(m)return promo(m[1],m[2]);

 m=core.match(/^(\d+)\s+products?$/i);
 if(m)return [`${m[1]} prodotti`,`${m[1]} productos`,`${m[1]} Produkte`,`${m[1]} produtos`][I];

 m=core.match(/^Claim\s+(?:your\s+)?free\s+(?:free|gift|gifts)!?$/i);
 if(m)return ['Scegli il tuo regalo gratuito!','¡Elige tu regalo gratis!','Wähle dein Gratisgeschenk!','Escolha a sua oferta grátis!'][I];

 m=core.match(/^Choose\s+(?:your\s+)?(?:free\s+)?gift!?$/i);
 if(m)return ['Scegli il tuo regalo gratuito','Elige tu regalo gratis','Wähle dein Gratisgeschenk','Escolha a sua oferta grátis'][I];

 m=core.match(/^Select\s+(?:your\s+)?(?:free\s+)?gift!?$/i);
 if(m)return ['Seleziona il tuo regalo gratuito','Selecciona tu regalo gratis','Wähle dein Gratisgeschenk aus','Selecione a sua oferta grátis'][I];

 m=core.match(/^Add\s+(.+?)\s+more\s+to\s+unlock\s+(?:your\s+)?(?:free\s+)?gift!?$/i);
 if(m)return [
  `Aggiungi ancora ${m[1]} per sbloccare il regalo gratuito`,
  `Añade ${m[1]} más para desbloquear el regalo gratis`,
  `Lege noch ${m[1]} in den Warenkorb, um das Gratisgeschenk freizuschalten`,
  `Adicione mais ${m[1]} para desbloquear a oferta grátis`
 ][I];

 m=core.match(/^You(?:'|’)re\s+(.+?)\s+away\s+from\s+(?:your\s+)?(?:free\s+)?gift!?$/i);
 if(m)return [
  `Ti mancano ${m[1]} per sbloccare il regalo gratuito`,
  `Te faltan ${m[1]} para desbloquear el regalo gratis`,
  `Noch ${m[1]} bis zum Gratisgeschenk`,
  `Faltam ${m[1]} para desbloquear a oferta grátis`
 ][I];

 return null;
}
function T(s){
 if(typeof s!=='string'||!s.trim())return s;
 const lead=(s.match(/^\s*/)||[''])[0],trail=(s.match(/\s*$/)||[''])[0];
 let k=N(s);
 let arrowStart='',arrowEnd='';
 const am=k.match(/^([→›>]+\s*)/);if(am){arrowStart=am[1];k=k.slice(am[1].length).trim();}
 const az=k.match(/(\s*[→›>]+)$/);if(az){arrowEnd=az[1];k=k.slice(0,-az[1].length).trim();}

 let parts=k.split(/\s*[·•]\s*/);
 if(parts.length>1){
  const translated=parts.map(coreTranslate);
  if(translated.every(Boolean))return lead+arrowStart+translated.join(' · ')+arrowEnd+trail;
 }

 const v=coreTranslate(k);
 return v?lead+arrowStart+v+arrowEnd+trail:s;
}

const seenRoots=new WeakSet();
const allRoots=new Set();
function applyNode(n){
 if(!n)return;
 if(n.nodeType===3){
  const p=n.parentElement;
  if(!p||p.closest('script,style,noscript,template'))return;
  if(handleUnlock(n))return;
  const z=T(n.nodeValue);if(z!==n.nodeValue)n.nodeValue=z;return;
 }
 if(n.nodeType!==1||n.matches('script,style,noscript,template'))return;
 ['aria-label','title','placeholder'].forEach(a=>{
  if(n.hasAttribute(a)){const v=n.getAttribute(a),z=T(v);if(z!==v)n.setAttribute(a,z);}
 });
}
function walk(root){
 if(!root)return;
 applyNode(root);
 const w=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT);
 let n;while(n=w.nextNode())applyNode(n);
}
function reconcile(){
 allRoots.forEach(r=>{
  try{
   const w=document.createTreeWalker(r,NodeFilter.SHOW_TEXT);
   let n;while(n=w.nextNode())handleUnlock(n);
  }catch(e){}
 });
}
function observe(root){
 if(!root||seenRoots.has(root))return;
 seenRoots.add(root);allRoots.add(root);walk(root);
 try{
  new MutationObserver(ms=>{
   ms.forEach(m=>{
    if(m.type==='characterData')applyNode(m.target);
    m.addedNodes.forEach(n=>{
     applyNode(n);
     if(n.nodeType===1||n.nodeType===11){
      walk(n);
      n.querySelectorAll?.('*').forEach(e=>e.shadowRoot&&observe(e.shadowRoot));
     }
    });
    if(m.type==='attributes')applyNode(m.target);
   });
   reconcile();
  }).observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','placeholder']});
 }catch(e){}
}
function scan(){
 (window.__hrCapturedShadowRoots||[]).forEach(observe);
 document.querySelectorAll('*').forEach(e=>e.shadowRoot&&observe(e.shadowRoot));
 document.querySelectorAll('iframe').forEach(f=>{try{f.contentDocument?.body&&observe(f.contentDocument.body)}catch(e){}});
}
try{
 if(!window.__hrUpnovaAttachShadowV2){
  window.__hrUpnovaAttachShadowV2=1;
  const old=Element.prototype.attachShadow;
  Element.prototype.attachShadow=function(init){
   const root=old.call(this,init);
   if(init&&init.mode==='open')setTimeout(()=>observe(root),0);
   return root;
  };
 }
}catch(e){}
window.addEventListener('hr:shadowroot',e=>observe(e.detail));
scan();setTimeout(scan,300);setTimeout(scan,1000);setInterval(()=>{scan();reconcile();},1200);
})();